import { category as categoryIcon } from "assets/icons";
import styled from "@emotion/styled";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputRef,
  Select,
  Space,
  Spin,
  message,
} from "antd";
import { FC, useEffect, useRef, useState } from "react";
import {
  GetMasterRetailType,
  MasterRetailTypeData,
  TagNameData,
} from "services/interface";
import {
  useAddTagName,
  useCreateTagName,
  useDeleteTagName,
  useGetMasterTagName,
  useGetRetailType,
} from "hooks/useMasterData";
import { useParams } from "react-router-dom";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { useAppSelector } from "store";

const { Option } = Select;

interface Option {
  value: string | number;
  label: string | number;
}

interface ProductTagnameProps {
  is_active?: boolean;
}

const ProductTagname: FC<ProductTagnameProps> = ({ is_active }) => {
  const [tagNameList, setTagNameList] = useState<TagNameData[]>([]);
  const inputRef = useRef<InputRef>(null);

 // const profile = useAppSelector((state) => state.auth.profile);
  //const factoryId = profile?.user.role.ref_id;
  const factoryId = useAppSelector((state) => state.auth.contact?.id);


  const [name, setName] = useState("");

  const { id } = useParams<{ id: string }>();

  const { data, isLoading, refetch } = useGetMasterTagName(factoryId || "");

  const { mutate } = useAddTagName();

  const { mutateAsync: createTagName } = useCreateTagName();

  const { mutateAsync: deleteTagName } = useDeleteTagName();

  useEffect(() => {
    if (data) {
      setTagNameList(data.data);
    }
  }, [data]);

  const onAddTagname = (value: string[]) => {
    // if (id && value) {
    //   mutate({
    //     ref_id: id,
    //     ref_type: "product",
    //     tag_list_id: value,
    //   });
    // }
  };

 

 const onDeleteTagname = (id: string) => {
    if (id) {
      deleteTagName({
        id: id,
      }, {
        onSuccess: (res) => {
          if (res.status === "success") {
            message.success("ลบ Tag สินค้าสำเร็จ");
            refetch();
          } else {
            message.error("ลบ Tag สินค้าไม่สำเร็จ");
          }
        },
        onError: () => {
          message.error("ลบ Tag สินค้าไม่สำเร็จ");
        },
      });
 };
}

  const onNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  };

  const addItem = async (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>
  ) => {
    e.preventDefault();
    if (name !== "") {
      await createTagName(
        {
          name: name,
          description: "",
          group_key: "tag_with_product",
        },
        {
          onSuccess: (res) => {
            if (res.status === "success") {
              setName("");
              inputRef.current?.focus();
              message.success("เพิ่ม Tag สินค้าสำเร็จ");
              refetch();
            } else {
              message.error("เพิ่ม Tag สินค้าไม่สำเร็จ");
            }
          },
          onError: () => {
            message.error("เพิ่ม Tag สินค้าไม่สำเร็จ");
          },
        }
      );
    }
    setName("");
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }}>
      <WrapperAll>
        <SpanIcon>{categoryIcon}</SpanIcon>
        <FormWrapper>
          <Form.Item
            label="Tag สินค้า"
            name="tag_list"
            rules={[{ required: is_active, message: "Tag สินค้า" }]}
          >
            <Select
              placeholder="Tag สินค้า"
              mode="multiple"
              optionLabelProp="label"
              onChange={onAddTagname}
              dropdownRender={(menu) => (
                <>
                  {menu}
                  <Divider style={{ margin: "8px 0" }} />
                  <Space style={{ padding: "0 8px 4px" }}>
                    <Input
                      placeholder="กรอก Tag สินค้า ที่ต้องการเพิ่ม"
                      ref={inputRef}
                      value={name}
                      onChange={onNameChange}
                      onKeyDown={(e) => e.stopPropagation()}
                    />
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={addItem}
                    >
                      เพิ่ม Tag สินค้า
                    </Button>
                  </Space>
                </>
              )}
            >
              {tagNameList !== undefined &&
                tagNameList.map((item) => {
                  return (
                    <Option key={item.id} value={item.id} label={item.name}>
                      <span>{item.name}</span>
                      <span style={{ float: "right" }}>
                        <DeleteOutlined
                          onClick={(e) => {
                            e.stopPropagation(); 
                            onDeleteTagname(item.id);
                          }}
                        />
                      </span>
                    </Option>
                  );
                })}
            </Select>
          </Form.Item>
        </FormWrapper>
      </WrapperAll>
    </Col>
  );
};

export default ProductTagname;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  border-radius: 8px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;
